// extracted by mini-css-extract-plugin
export default {"nav":"LeftSideNav_nav__oeJC5","menuItems":"LeftSideNav_menuItems__PFlQj","subMenu":"LeftSideNav_subMenu__ht5Gs"};